module.exports = __webpack_public_path__ + "img/Bangkok Bank PCL.90236e1d.png";